var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activity)?_c('scopes-technical-table',{attrs:{"activity":_vm.activity,"title":['OCPR', 'OCPE', 'OINSP', 'OVV'].includes(this.activity)
        ? 'ALCANCE DE LA ACREDITACIÓN SOLICITADA'
        : ['CSGAS', 'OCSG', 'CSA', 'CSIA', 'OEAP', 'CSST', 'CSEN'].includes(this.activity)
        ? 'ALCANCE DE ACREDITACIÓN'
        : ['OENY', 'OEYC', 'CSDM'].includes(this.activity)
        ? 'ALCANCE DE LA ACREDITACIÓN'
        : ['OCLN', 'OICC'].includes(this.activity)
        ? 'ALCANCE DE LA ACREDITACIÓN'
        : ''}}):_vm._e(),_vm._v(" "),(['OENY', 'OICC'].includes(this.activity))?_c('div',[_c('scope-sampling-table',{attrs:{"title":"¿Incluye muestreo?","tableId":"scope-sampling-table","modalTitle":"Añadir Muestra","editModalTitle":"Editar Muestra","activity":_vm.activity,"disabled":_vm.disabled}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }